import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useAnonymousUser } from '../app/hooks/useAnonymousUser';
import { PATH_FORBIDDEN } from './constants';

// eslint-disable-next-line @typescript-eslint/ban-types
type PrivateRouteProps<RouteComponentProps = {}> = RouteProps & {
  userIsAuth: boolean;
  component: React.ComponentType<RouteComponentProps> | RouteComponentProps;
};

// eslint-disable-next-line react/prop-types
const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: RouteComponent, userIsAuth, ...rest }) => {
  const isUserAnonymous = useAnonymousUser();

  if (isUserAnonymous) {
    return <Redirect to={`${PATH_FORBIDDEN}?guest=true`} />;
  }
  return (
    <Route {...rest} render={(routeProps) => (userIsAuth ? <RouteComponent {...routeProps} /> : <Redirect to="/login" />)} />
  );
};

export default PrivateRoute;
